import React, { useState, useRef, useEffect } from "react";
import '../../../scss/TypeTracNghiem.scss'
import he from 'he';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ThiTrucTuyenService } from 'services/ThiTrucTuyenService';
import { Toast } from 'primereact/toast';

const TypeSapXepV2 = (props) => {
    const { data, overview, userId } = props;
    let arrAnswer = null;
    if (data.selected != null && data.selected.vanbantraloi && data.selected.vanbantraloi.trim() !== "") {
        try {
            const arr = JSON.parse(data.selected.vanbantraloi);
            arrAnswer = arr;
        } catch (error) {
            console.error('Error parsing vanbantraloi:', error);
            console.error('vanbantraloi value:', data.selected.vanbantraloi);
            arrAnswer = null;
        }
    }
    const exampleAnswer = (data?.lstdapan || []).find(item => item.is_example == 1);
    const nonExampleAnswers = (data?.lstdapan || []).filter(item => item.is_example != 1);
    const initialData = {
        table1: [
            exampleAnswer ? { ...exampleAnswer, _isExample: true } : { vanbanphanhoi: "" },
            { vanbanphanhoi: "" },
            { vanbanphanhoi: "" },
            { vanbanphanhoi: "" },
            { vanbanphanhoi: "" },
            { vanbanphanhoi: "" },
        ],
        table2: nonExampleAnswers
    };
    const [lstDapAn, setlstDapAn] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dataDrop, setDataDrop] = useState(arrAnswer || initialData);
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const toast = useRef(null);
    const IdDeThi = localStorage.getItem('IdDeThi');

    useEffect(() => {

    }, [dataDrop]);

    const submitQuestion = async (strData) => {
        const body = {
            user_id: userId,
            id_cauhoi: data.id,
            vanbantraloi: strData,
            loaibaithi: 1,
            attempt_code: localStorage.getItem('exam_attempt_code') || null,
            dethitructuyen_id: localStorage.getItem('IdDeThi'),
            type_exam: localStorage.getItem('typeExam')
        }
        await ThiTrucTuyenService.submitquestionsx(body);
    }


    const onDragEnd = (result) => {
        if (!result.destination) return;

        const sourceTable = result.source.droppableId;
        const destTable = result.destination.droppableId;
        const destinationIndex = result.destination.index;

        if (sourceTable === 'table2' && destTable === 'table1' && destinationIndex > 0 && destinationIndex < dataDrop.table1.length) {
            const sourceItems = Array.from(dataDrop[sourceTable]);
            const destItems = Array.from(dataDrop[destTable]);

            const [movedItem] = sourceItems.splice(result.source.index, 1);
            const replacedItem = destItems[destinationIndex];
            destItems[destinationIndex] = movedItem;

            if (replacedItem.vanbanphanhoi !== "") {
                sourceItems.push(replacedItem);
            }

            setDataDrop({
                table1: destItems,
                table2: sourceItems
            });
            let arr = {
                table1: destItems,
                table2: sourceItems
            }
            const jsonString = JSON.stringify(arr);
            submitQuestion(jsonString);

        } else if (sourceTable === 'table1' && destTable === 'table1') {
            // Không cho kéo vào/ra khỏi slot 0 (example cố định)
            if (result.source.index === 0 || destinationIndex === 0) return;

            const items = Array.from(dataDrop[sourceTable]);
            const [movedItem] = items.splice(result.source.index, 1);
            items.splice(destinationIndex, 0, movedItem);

            const newState = { ...dataDrop, [sourceTable]: items };
            setDataDrop(newState);
            submitQuestion(JSON.stringify(newState));

        } else if (sourceTable === 'table1' && destTable === 'table2' && dataDrop.table1[result.source.index]) {
            // Không cho kéo slot 0 (example cố định) ra ngoài
            if (result.source.index === 0) return;
            const sourceItems = Array.from(dataDrop[sourceTable]);
            const destItems = Array.from(dataDrop[destTable]);
            if (sourceItems[result.source.index].vanbanphanhoi !== "") {
                const [movedItem] = sourceItems.splice(result.source.index, 1);
                destItems.splice(destinationIndex, 0, movedItem);

                sourceItems.splice(result.source.index, 0, { vanbanphanhoi: "" });

                setDataDrop({
                    table1: sourceItems,
                    table2: destItems
                });
                let arr = {
                    table1: sourceItems,
                    table2: destItems
                }
                const jsonString = JSON.stringify(arr);
                submitQuestion(jsonString);
            }

        } else if (sourceTable === 'table2' && destTable === 'table2') {
            const items = Array.from(dataDrop[sourceTable]);
            const [movedItem] = items.splice(result.source.index, 1);
            items.splice(destinationIndex, 0, movedItem);

            const newState = { ...dataDrop, [sourceTable]: items };
            setDataDrop(newState);
            submitQuestion(JSON.stringify(newState));
        }
    };

    const toggleAudio = async () => {
        try {
            const el = audioRef.current;
            if (!el) return;

            const playCountKey = `playCount_${userId}_${data.id}_${IdDeThi}`;
            const currentCount = parseInt(localStorage.getItem(playCountKey) || '0');

            if (isPlaying) {
                el.pause();
                setIsPlaying(false);
            } else {
                if (currentCount >= 2) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Notice',
                        detail: 'You have reached the maximum number of listens for this question (max 2 times).',
                        life: 3000
                    });
                    return;
                }

                // Nếu bắt đầu nghe (lượt 1 hoặc 2), thì nghe lại từ đầu
                el.currentTime = 0;
                await el.play();
                setIsPlaying(true);

                const newCount = currentCount + 1;
                localStorage.setItem(playCountKey, newCount);
            }
        } catch (e) {
            // ignore play error
        }
    };
    useEffect(() => {
        setLoading(true);
        let newarrr = [...(data?.lstdapan || [])];
        setlstDapAn(newarrr);
        if (arrAnswer == null) {
            // Tách example ra khỏi danh sách, đặt vào slot đầu table1
            const exAns = newarrr.find(item => item.is_example == 1);
            const nonExAns = newarrr.filter(item => item.is_example != 1);
            let initialData = {
                table1: [
                    exAns ? { ...exAns, _isExample: true } : { vanbanphanhoi: "" },
                    { vanbanphanhoi: "" },
                    { vanbanphanhoi: "" },
                    { vanbanphanhoi: "" },
                    { vanbanphanhoi: "" },
                    { vanbanphanhoi: "" },
                ],
                table2: nonExAns
            };
            setDataDrop(initialData);
        }
        setTimeout(() => {
            setLoading(false);
        }, 1000);

    }, [])

    return (
        <>
            <div className="conatiner-div1">
                {
                    loading
                        ?
                        <div style={{ textAlign: 'center' }}>
                            <ProgressSpinner />
                        </div>
                        :
                        <div>
                            {/* <div className="d-flex mt-3">
                                <div className="mr-3" style={{
                                    padding: '16px 20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '10px',
                                    borderLeft: '4px solid #23085a',
                                    width: '100%'
                                }}>
                                    <span
                                        style={{
                                            fontSize: '15px',
                                            lineHeight: '1.7',
                                            color: '#333',
                                            fontWeight: '500'
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: he.decode(data.vanbancauhoi)
                                        }}
                                    />
                                </div>
                            </div> */}
                            <div style={{ marginTop: '16px', marginBottom: '8px' }}>
                                {data.ma == "NGHE" && data.file &&
                                    <div style={{ marginTop: '20px', width: '100%' }}>
                                        <audio
                                            controlsList="nodownload"
                                            key={data.id}
                                            ref={audioRef}
                                            style={{ display: 'none' }}
                                            onEnded={() => setIsPlaying(false)}
                                        >
                                            <source src={data.file} type="audio/ogg" />
                                            <source src={data.file} type="audio/mpeg" />
                                        </audio>
                                        <button
                                            type="button"
                                            className="btn-audio-toggle"
                                            onClick={toggleAudio}
                                        >
                                            <span className="icon">{isPlaying ? '⏸' : '⏵'}</span>
                                            <span className="text">
                                                <u>{isPlaying ? 'Stop' : 'Play'}</u>
                                            </span>
                                        </button>
                                    </div>
                                }
                            </div>
                            <div className="mt-3" style={{ display: 'flex', justifyContent: 'center', gap: '5%', marginTop: '20px' }}>
                                {
                                    overview ?
                                        (() => {
                                            // Tính số cặp liền kề đúng (adjacent correct pairs)
                                            // So sánh dựa trên ID của đáp án thay vì vanbanphanhoi để chính xác hơn
                                            const userAnswers = dataDrop.table1;
                                            const correctAnswers = lstDapAn;
                                            const adjacentPairs = [];
                                            
                                            for (let i = 0; i < userAnswers.length - 1; i++) {
                                                const userCurrent = userAnswers[i]?.id || userAnswers[i]?.vanbanphanhoi;
                                                const userNext = userAnswers[i + 1]?.id || userAnswers[i + 1]?.vanbanphanhoi;
                                                const correctCurrent = correctAnswers[i]?.id || correctAnswers[i]?.vanbanphanhoi;
                                                const correctNext = correctAnswers[i + 1]?.id || correctAnswers[i + 1]?.vanbanphanhoi;
                                                
                                                // Cặp đúng khi cả 2 phần tử liền kề đều khớp với đáp án đúng
                                                const isPairCorrect = userCurrent && userNext && 
                                                    userCurrent === correctCurrent && userNext === correctNext;
                                                adjacentPairs.push(isPairCorrect);
                                            }
                                            
                                            const correctPairCount = adjacentPairs.filter(Boolean).length;
                                            
                                            // Bảng quy đổi: Số cặp đúng → Điểm thô
                                            const pairToRawScore = { 0: 0, 1: 1, 2: 2, 3: 2, 4: 2, 5: 3 };
                                            const rawScore = pairToRawScore[correctPairCount] !== undefined 
                                                ? pairToRawScore[correctPairCount] 
                                                : 0;

                                            return (
                                        <div style={{ width: '100%' }}>
                                            <div style={{ overflow: 'hidden', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                                            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{
                                                            textAlign: 'center',
                                                            fontWeight: '600',
                                                            fontSize: '15px',
                                                            border: 'none',
                                                            padding: '16px',
                                                            width: '45%',
                                                            backgroundColor: '#23085a',
                                                            color: '#fff'
                                                        }}>
                                                            Your answer
                                                        </th>
                                                        <th style={{
                                                            textAlign: 'center',
                                                            fontWeight: '600',
                                                            fontSize: '15px',
                                                            border: 'none',
                                                            padding: '16px',
                                                            width: '10%',
                                                            backgroundColor: '#4a2d7a',
                                                            color: '#fff'
                                                        }}>
                                                            Pair status
                                                        </th>
                                                        <th style={{
                                                            textAlign: 'center',
                                                            fontWeight: '600',
                                                            fontSize: '15px',
                                                            border: 'none',
                                                            padding: '16px',
                                                            width: '45%',
                                                            backgroundColor: '#dc3545',
                                                            color: '#fff'
                                                        }}>
                                                            Correct answer
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dataDrop.table1.map((item, index) => {
                                                        const isCorrect = (item.id || item.vanbanphanhoi) === (lstDapAn[index]?.id || lstDapAn[index]?.vanbanphanhoi);
                                                        // Mỗi hàng chỉ hiển thị 1 cặp liền kề: (index, index+1)
                                                        const hasPairBelow = index < adjacentPairs.length;
                                                        const isPairCorrect = hasPairBelow ? adjacentPairs[index] : null;
                                                        
                                                        return (
                                                            <tr key={index} style={{
                                                                backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa',
                                                                transition: 'background-color 0.2s ease'
                                                            }}>
                                                                {/* Cột Trả lời */}
                                                                <td style={{
                                                                    border: '1px solid #e9ecef',
                                                                    padding: '14px 16px',
                                                                    verticalAlign: 'top'
                                                                }}>
                                                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                                        <span style={{
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            width: '26px',
                                                                            height: '26px',
                                                                            borderRadius: '50%',
                                                                            backgroundColor: isCorrect ? '#28a745' : '#dc3545',
                                                                            color: '#fff',
                                                                            fontWeight: '600',
                                                                            fontSize: '13px',
                                                                            flexShrink: 0
                                                                        }}>
                                                                            {index}
                                                                        </span>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{ __html: item.vanbanphanhoi || '<span style="color: #999; font-style: italic;">Not answered</span>' }}
                                                                            style={{
                                                                                flex: 1,
                                                                                lineHeight: '1.6',
                                                                                color: item.vanbanphanhoi ? '#333' : '#999',
                                                                                fontSize: '14px'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </td>

                                                                {/* Cột Pair - hiển thị trạng thái cặp dễ đọc */}
                                                                <td style={{
                                                                    border: '1px solid #e9ecef',
                                                                    padding: '4px 8px',
                                                                    verticalAlign: 'middle',
                                                                    textAlign: 'center'
                                                                }}>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '4px' }}>
                                                                        {hasPairBelow && (
                                                                            <div style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'space-between',
                                                                                gap: '6px',
                                                                                padding: '4px 8px',
                                                                                borderRadius: '12px',
                                                                                backgroundColor: isPairCorrect ? '#d4edda' : '#f8d7da',
                                                                                border: `1px solid ${isPairCorrect ? '#28a745' : '#dc3545'}`,
                                                                                fontSize: '11px',
                                                                                fontWeight: '600',
                                                                                color: isPairCorrect ? '#155724' : '#721c24',
                                                                            }}>
                                                                                <span>{index}-{index + 1}</span>
                                                                                <span style={{ fontWeight: '700' }}>{isPairCorrect ? '✓' : '✗'}</span>
                                                                            </div>
                                                                        )}
                                                                        {!hasPairBelow && (
                                                                            <div style={{ color: '#94a3b8', fontSize: '11px', fontStyle: 'italic' }}>
                                                                                -
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
 
                                                                {/* Cột Đáp án */}
                                                                <td style={{
                                                                    border: '1px solid #e9ecef',
                                                                    padding: '14px 16px',
                                                                    verticalAlign: 'top'
                                                                }}>
                                                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                                        <span style={{
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            width: '26px',
                                                                            height: '26px',
                                                                            borderRadius: '50%',
                                                                            backgroundColor: '#dc3545',
                                                                            color: '#fff',
                                                                            fontWeight: '600',
                                                                            fontSize: '13px',
                                                                            flexShrink: 0
                                                                        }}>
                                                                            {index}
                                                                        </span>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{ __html: lstDapAn[index]?.vanbanphanhoi || '' }}
                                                                            style={{
                                                                                flex: 1,
                                                                                lineHeight: '1.6',
                                                                                color: '#333',
                                                                                fontSize: '14px'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                            </div>

                                            {/* Bảng tổng kết cặp đúng và điểm thô */}
                                            <div style={{
                                                marginTop: '16px',
                                                padding: '16px 20px',
                                                borderRadius: '12px',
                                                background: 'linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)',
                                                border: '1px solid #e0e7ff',
                                                boxShadow: '0 2px 8px rgba(99, 102, 241, 0.08)'
                                            }}>
                                                <div style={{ 
                                                    display: 'flex', 
                                                    justifyContent: 'space-between', 
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                    gap: '12px'
                                                }}>
                                                    {/* Chi tiết các cặp */}
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ 
                                                            fontWeight: '700', 
                                                            fontSize: '14px', 
                                                            color: '#1e1b4b', 
                                                            marginBottom: '10px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }}>
                                                            🔗 Adjacent Pairs (Cặp liền kề)
                                                        </div>
                                                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                            {adjacentPairs.map((isOk, idx) => (
                                                                <div key={idx} style={{
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    gap: '4px',
                                                                    padding: '4px 10px',
                                                                    borderRadius: '8px',
                                                                    backgroundColor: isOk ? '#d4edda' : '#f8d7da',
                                                                    border: `1px solid ${isOk ? '#28a745' : '#dc3545'}`,
                                                                    fontSize: '12px',
                                                                    fontWeight: '600',
                                                                    color: isOk ? '#155724' : '#721c24',
                                                                }}>
                                                                    <span>{isOk ? '✓' : '✗'}</span>
                                                                    <span>Pair {idx}-{idx + 1}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    {/* Kết quả điểm */}
                                                    <div style={{ 
                                                        display: 'flex', 
                                                        gap: '16px', 
                                                        alignItems: 'center',
                                                        padding: '12px 20px',
                                                        backgroundColor: '#fff',
                                                        borderRadius: '12px',
                                                        border: '1px solid #e2e8f0',
                                                        boxShadow: '0 1px 4px rgba(0,0,0,0.04)'
                                                    }}>
                                                        <div style={{ textAlign: 'center' }}>
                                                            <div style={{ fontSize: '22px', fontWeight: '800', color: '#6366f1' }}>
                                                                {correctPairCount}/{adjacentPairs.length}
                                                            </div>
                                                            <div style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase' }}>
                                                                Cặp đúng
                                                            </div>
                                                        </div>
                                                        <div style={{ 
                                                            width: '1px', 
                                                            height: '36px', 
                                                            backgroundColor: '#e2e8f0' 
                                                        }} />
                                                        <div style={{ textAlign: 'center' }}>
                                                            <div style={{ fontSize: '22px', fontWeight: '800', color: '#1e1b4b' }}>
                                                                {rawScore}
                                                            </div>
                                                            <div style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase' }}>
                                                                Điểm thô
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Bảng quy đổi nhỏ */}
                                                <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e0e7ff' }}>
                                                    <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600', marginBottom: '6px' }}>
                                                        Bảng quy đổi:
                                                    </div>
                                                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                                        {Object.entries(pairToRawScore).map(([pairs, score]) => (
                                                            <div key={pairs} style={{
                                                                padding: '3px 8px',
                                                                borderRadius: '6px',
                                                                fontSize: '11px',
                                                                fontWeight: '600',
                                                                backgroundColor: parseInt(pairs) === correctPairCount ? '#6366f1' : '#f1f5f9',
                                                                color: parseInt(pairs) === correctPairCount ? '#fff' : '#64748b',
                                                                border: `1px solid ${parseInt(pairs) === correctPairCount ? '#6366f1' : '#e2e8f0'}`,
                                                                transition: 'all 0.2s ease'
                                                            }}>
                                                                {pairs} cặp → {score} điểm
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                            );
                                        })()

                                        :

                                        <DragDropContext onDragEnd={onDragEnd}>
                                            {['table1', 'table2'].map((tableId) => (
                                                <Droppable key={tableId} droppableId={tableId}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.droppableProps}
                                                            style={{
                                                                width: '50%',
                                                                padding: '16px',
                                                                border: snapshot.isDraggingOver
                                                                    ? '2px dashed #23085a'
                                                                    : '2px solid #e0e0e0',
                                                                borderRadius: '14px',
                                                                minHeight: '200px',
                                                                backgroundColor: snapshot.isDraggingOver
                                                                    ? '#e7f3ff'
                                                                    : tableId === 'table1'
                                                                        ? '#ffffff'
                                                                        : '#eee8f5',
                                                                boxShadow: snapshot.isDraggingOver
                                                                    ? '0 8px 20px rgba(0, 92, 185, 0.15)'
                                                                    : '0 4px 12px rgba(0,0,0,0.08)',
                                                                transition: 'all 0.3s ease',
                                                                position: 'relative'
                                                            }}
                                                        >
                                                            {/* Label */}
                                                            <div style={{
                                                                marginBottom: '16px',
                                                                paddingBottom: '12px',
                                                                borderBottom: '2px solid #e9ecef'
                                                            }}>
                                                                <h3 style={{
                                                                    margin: 0,
                                                                    fontSize: '15px',
                                                                    fontWeight: '600',
                                                                    color: tableId === 'table1' ? '#23085a' : '#23085a',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px'
                                                                }}>
                                                                    <span style={{
                                                                        display: 'inline-block',
                                                                        width: '8px',
                                                                        height: '8px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: tableId === 'table1' ? '#23085a' : '#23085a'
                                                                    }}></span>
                                                                    {tableId === 'table1' ? 'Drag and drop here to arrange' : 'Answer list'}
                                                                </h3>
                                                            </div>

                                                            {/* Items */}
                                                            {dataDrop[tableId].map((item, index) => (
                                                                <Draggable
                                                                    key={tableId + '-' + index}
                                                                    draggableId={tableId + '-' + index}
                                                                    index={index}
                                                                    isDragDisabled={(tableId === 'table1' && item.vanbanphanhoi === "") || (tableId === 'table1' && item._isExample === true)}
                                                                >
                                                                    {(provided, snapshot) => (
                                                                        <div
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            style={{
                                                                                userSelect: 'none',
                                                                                padding: item.vanbanphanhoi ? '8px 12px' : '8px',
                                                                                margin: '6px 0',
                                                                                border: item.vanbanphanhoi
                                                                                    ? snapshot.isDragging
                                                                                        ? '2px solid #23085a'
                                                                                        : '2px solid #d0d7de'
                                                                                    : '2px dashed #cbd5e0',
                                                                                borderRadius: '10px',
                                                                                backgroundColor: item.vanbanphanhoi
                                                                                    ? snapshot.isDragging
                                                                                        ? '#e7f3ff'
                                                                                        : '#ffffff'
                                                                                    : '#f8f9fa',
                                                                                transition: 'all 0.2s ease',
                                                                                cursor: tableId === 'table1' && item.vanbanphanhoi === "" ? 'not-allowed' : 'grab',
                                                                                boxShadow: snapshot.isDragging
                                                                                    ? '0 6px 16px rgba(0, 92, 185, 0.25)'
                                                                                    : item.vanbanphanhoi
                                                                                        ? '0 2px 6px rgba(0,0,0,0.08)'
                                                                                        : 'none',
                                                                                transform: snapshot.isDragging ? 'rotate(1deg) scale(1.02)' : 'none',
                                                                                ...provided.draggableProps.style,
                                                                                zIndex: snapshot.isDragging ? 1000 : 0
                                                                            }}
                                                                        >
                                                                            {item.vanbanphanhoi ? (
                                                                                <div style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'flex-start',
                                                                                    gap: '12px'
                                                                                }}>
                                                                                    <span style={{
                                                                                        display: 'inline-flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        width: '26px',
                                                                                        height: '26px',
                                                                                        borderRadius: '50%',
                                                                                        backgroundColor: tableId === 'table1' ? '#23085a' : '#23085a',
                                                                                        color: '#fff',
                                                                                        fontWeight: '600',
                                                                                        fontSize: '13px',
                                                                                        flexShrink: 0
                                                                                    }}>
                                                                                        {tableId === 'table1' ? index : index + 1}
                                                                                    </span>
                                                                                    <div
                                                                                        style={{
                                                                                            flex: 1,
                                                                                            lineHeight: '1.6',
                                                                                            color: '#333',
                                                                                            fontSize: '14px'
                                                                                        }}
                                                                                        dangerouslySetInnerHTML={{ __html: item.vanbanphanhoi }}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    minHeight: '30px',
                                                                                    color: '#999',
                                                                                    fontStyle: 'italic',
                                                                                    fontSize: '13px'
                                                                                }}>
                                                                                    Drag answer here
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                            {provided.placeholder}
                                                        </div>
                                                    )}
                                                </Droppable>
                                            ))}
                                        </DragDropContext>
                                }

                            </div>
                        </div>
                }


            </div>


            <Toast ref={toast} />
        </>
    );
}

export default TypeSapXepV2;